export const environment = {
    production: false,
    apigee: 'https://api-dev.cord.pe/cord-public',
    url: 'https://api-dev.cord.pe/cord-backoffice',
    login: 'https://api-dev.cord.pe/cord-public/management/login',
    apiKey: "AIzaSyA76JItDnwEnp3wBtatXX9m8PgSo01znfU",
    headerDeeplink: "dev.express.com://",
    deeplink: 'user/webview?title=Ver Términos y Condiciones.&url=',
    storeIdJokr: '2f61cf70-fbaa-4627-8dcc-749cf93cb3f1',
    storeIdMerkao: 'e1cd2bc9-a99f-46ca-8157-7fbee65bbf6c',
    flagV2Stores: ['dc08ce97-0e18-4039-ab4c-c436a407afc0'], // Vivanda
    firebaseConfig: {
      apiKey: "AIzaSyA76JItDnwEnp3wBtatXX9m8PgSo01znfU",
      authDomain: "pe-grupo-intercorp-cld-01.firebaseapp.com",
      databaseURL: "https://pe-grupo-intercorp-cld-01.firebaseio.com",
      projectId: "pe-grupo-intercorp-cld-01",
      storageBucket: "pe-grupo-intercorp-cld-01.appspot.com",
      messagingSenderId: "1072951202997",
      appId: "1:1072951202997:web:42b8de347c937e92539afc",
      measurementId: "G-F1ZQB1LHKS"
    }
  };


// {​​​​​​​​ content_name = "API_MANAGER_URL_TOKEN", content_value = "https://api.indigital.com.pe/prod/oauth/access-token" }​​​​​​​​,
// {​​​​​​​​ content_name = "API_MANAGER_CLIENT_ID", content_value = "1fe1ab56-33b0-310c-ab52-55f59f3909fe" }​​​​​​​​,
// {​​​​​​​​ content_name = "API_MANAGER_CLIENT_SECRET", content_value = "ba1bee98-4776-3cb5-a3df-d5777eb85479" }​​​​​​​​,


